<script>
import Layout from "../../../layouts/main.vue";
import ClientsList from "../ClientsList.vue";

export default {
    components: { Layout, ClientsList },
    props: {
        all_user: {
            type: Array,
            default: function() {
                return []
            }
        },
        paginationDetails: {
            type: Object,
            default: function() {
                return {}
            }
        },
        filters: {
            type: Object,
            default: function() {
                return {}
            }
        },
        referralDetails: {
            type: Array,
            default: function() {
                return []
            }
        },
        allStripePlans: {
            type: Object,
            default: function() {
                return {}
            }
        },
    },

    computed: {
        userPermissions() {
            return this.$page.props.auth.user.user_permission;
        },
    }
};
</script>

<template>
    <Layout>
        <Head :title="'Enterprise Partner - Tax Companies'" />
        <!-- start page title -->
        <div class="row">
            <div class="col-12">
                <div
                    class="page-title-box d-flex align-items-center justify-content-between"
                >
                    <h4 class="mb-0 font-size-18">Tax Companies</h4>
                </div>
            </div>
        </div>

        <ClientsList 
            :all_user="all_user"
            :paginationDetails="paginationDetails"
            :filters="filters"
            :referralDetails="referralDetails"
            :allStripePlans="allStripePlans"
            clientListType="TC"
            modalTitle="Tax Company"
            :createClientRoute="!userPermissions || userPermissions.tc_clients ? route('tc-create') : null"
            :inviteClientRoute="!userPermissions || userPermissions.tc_clients ? route('tc-invitation-process') : null"
            :importCsvToInviteRoute="route('sb-import-csv', ['tc'])"
            exportCsvUrl="/sb/export-tc-list"
            exportCsvFilename="EnterprisePartnerToTc.csv"
            :type="3"
            :submitType="4"
        />
    </Layout>
</template>
